import { useEffect, useState } from "react";

function useMicrofrontendLoading() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const showLoader = () => {
      setIsLoading(true);
    };

    const hideLoader = () => {
      setIsLoading(false);
    };

    window.addEventListener("single-spa:before-app-change", showLoader);
    window.addEventListener("single-spa:routing-event", hideLoader);

    return () => {
      window.removeEventListener("single-spa:before-app-change", showLoader);
      window.removeEventListener("single-spa:routing-event", hideLoader);
    };
  }, []);

  return isLoading;
}

export { useMicrofrontendLoading };
